export class CustomRuleCategoryApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCustomRuleCategory() {
    return this.#http.get('/customRuleCategory');
  }
}
